var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"monitor-title-bar",attrs:{"color":"#0041c0"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.Title))]),_c('v-toolbar-title',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.areaName))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }